import {
  IPublicClientApplication,
  PublicClientApplication,
  InteractionType,
  BrowserCacheLocation,
  LogLevel,
} from '@azure/msal-browser';
import {
  MsalInterceptorConfiguration,
  MSAL_GUARD_CONFIG,
  MSAL_INSTANCE,
  MSAL_INTERCEPTOR_CONFIG,
  MsalGuardConfiguration,
} from '@azure/msal-angular';
import { AppConfig } from 'src/app/configs/app.config';
import { environment } from 'src/environments/environment';
//import { MsalGuardConfigurationB2C } from '@azure/msal-angular/msal.guard.config';

export const isIE =
  window.navigator.userAgent.indexOf('MSIE ') > -1 ||
  window.navigator.userAgent.indexOf('Trident/') > -1;

export function loggerCallback(logLevel: LogLevel, message: string) {
  console.log(message);
}

export function MSALInstanceFactory(): IPublicClientApplication {
  return new PublicClientApplication({
    auth: {
      clientId: environment.msalConfig.clientId,
      authority: environment.msalConfig.authorityUrl,
      redirectUri: environment.msalConfig.redirectUri,
      // redirectUri: environment.msalConfig.redirectUri + '/home',
      // postLogoutRedirectUri: environment.msalConfig.redirectUri + '/login',
      postLogoutRedirectUri: '/',
    },
    cache: {
      cacheLocation: BrowserCacheLocation.LocalStorage,
      storeAuthStateInCookie: isIE, // set to true for IE 11
    },
    system: {
      loggerOptions: {
        loggerCallback,
        logLevel: LogLevel.Warning,
        // logLevel: LogLevel.Info,
        piiLoggingEnabled: false,
      },
    },
  });
}

export function MSALInstanceFactoryB2C(
  isResetPassword: boolean = false
): IPublicClientApplication {
  let authProd = {
    clientId: environment.msalConfig.clientIdB2C,
    // authority: environment.msalConfig.authorityUrl,
    redirectUri: environment.msalConfig.redirectUriB2C,
    postLogoutRedirectUri: '/',
    authority: isResetPassword
      ? b2cPolicies.authorities.resetPassword.authority
      : b2cPolicies.authorities.signUpSignIn.authority,
    knownAuthorities: [b2cPolicies.authorityDomain],
  };
  let authDev = {
    clientId: environment.msalConfig.clientIdB2C,
    redirectUri: environment.msalConfig.redirectUriB2C,
    postLogoutRedirectUri: '/',
    authority: isResetPassword
      ? b2cPolicies.authorities.resetPassword.authority
      : b2cPolicies.authorities.signUpSignIn.authority,
    knownAuthorities: [b2cPolicies.authorityDomain],
  };
  return new PublicClientApplication({
    // auth: {
    //   clientId: environment.msalConfig.clientIdB2C,
    //   // authority: environment.msalConfig.authorityUrlB2C,
    //   redirectUri: environment.msalConfig.redirectUriB2C,
    //   // redirectUri: environment.msalConfig.redirectUri + '/home',
    //   // postLogoutRedirectUri: environment.msalConfig.redirectUri + '/login',
    //   postLogoutRedirectUri: '/',
    //   authority: b2cPolicies.authorities.signUpSignIn.authority,
    //   knownAuthorities: [b2cPolicies.authorityDomain],
    // },
    auth: environment.production ? authProd : authDev,
    cache: {
      cacheLocation: BrowserCacheLocation.LocalStorage,
      storeAuthStateInCookie: isIE, // set to true for IE 11
    },
    system: {
      loggerOptions: {
        loggerCallback,
        logLevel: LogLevel.Warning,
        // logLevel: LogLevel.Info,
        piiLoggingEnabled: false,
      },
    },
  });
}
export function MSALInstanceFactoryB2CLogout(): IPublicClientApplication {
  return new PublicClientApplication({
    auth: {
      clientId: environment.msalConfig.clientIdB2C,
      redirectUri: environment.msalConfig.redirectUriB2C,
      postLogoutRedirectUri: environment.msalConfig.redirectUriB2C,
      // postLogoutRedirectUri: `${b2cPolicies.authorities.signUpSignIn.authority}/oauth2/v2.0/logout?post_logout_redirect_uri=${environment.msalConfig.redirectUriB2C}`,
      authority: b2cPolicies.authorities.signUpSignIn.authority,
      // authority: `${b2cPolicies.authorities.signUpSignIn.authority}/oauth2/v2.0/logout`,
      knownAuthorities: [b2cPolicies.authorityDomain],
    },
    cache: {
      cacheLocation: BrowserCacheLocation.LocalStorage,
      storeAuthStateInCookie: isIE, // set to true for IE 11
    },
    system: {
      loggerOptions: {
        loggerCallback,
        logLevel: LogLevel.Warning,
        // logLevel: LogLevel.Info,
        piiLoggingEnabled: false,
      },
    },
  });
}

export function MSALInterceptorConfigFactory(): MsalInterceptorConfiguration {
  const protectedResourceMap = new Map<string, Array<string>>();
  protectedResourceMap.set(environment.msalConfig.graphUrl, [
    'user.read',
    'profile',
  ]);

  // if (environment.msalConfig.apimFlag) {
  //   AppConfig.AUTH_API.forEach((element) => {
  //     //protectedResourceMap.set(environment.baseUrl + element + "*", [`${environment.clientId}/openid`]);
  //     //protectedResourceMap.set(environment.baseUrl + element + "*", [`${environment.clientIdB2C}/openid`]);
  //   });
  // }

  return {
    interactionType: InteractionType.Redirect,
    protectedResourceMap,
  };
}

export function MSALGuardConfigFactory(): MsalGuardConfiguration {
  return {
    interactionType: InteractionType.Redirect,
    authRequest: {
      scopes: ['user.read'],
      // domainHint: 'scg.com',
      // loginHint: 'userlogin@scg.com',
    },
    loginFailedRoute: '/login',
  };
}

export const b2cPolicies = {
  names: {
    // signUpSignIn: 'b2c_1_susi_reset_v2',
    // signUpSignIn: 'B2C_1_sing-in_test',
    // editProfile: 'b2c_1_edit_profile_v2',
    // resetPassword: 'B2C_1_reset-password-flow',
    signUpSignIn: environment.msalConfig.signUpSignInB2C,
    editProfile: environment.msalConfig.editProfileB2C,
    resetPassword: environment.msalConfig.resetPasswordB2C,
  },
  authorities: {
    signUpSignIn: {
      authority:
        // 'https://scgchemb2cdev.b2clogin.com/scgchemb2cdev.onmicrosoft.com/b2c_1_susi_reset_v2',
        // 'https://scgchemb2cdev.b2clogin.com/scgchemb2cdev.onmicrosoft.com/B2C_1_sing-in_test',
        environment.msalConfig.authorityUrlB2C + environment.msalConfig.signUpSignInB2C,
    },
    editProfile: {
      authority:
        // 'https://scgchemb2cdev.b2clogin.com/scgchemb2cdev.onmicrosoft.com/b2c_1_edit_profile_v2',
        environment.msalConfig.authorityUrlB2C + environment.msalConfig.editProfileB2C,
    },
    resetPassword: {
      authority:
        // 'https://scgchemb2cdev.b2clogin.com/scgchemb2cdev.onmicrosoft.com/b2c_1_edit_profile_v2',
        environment.msalConfig.authorityUrlB2C + environment.msalConfig.resetPasswordB2C,
    },
  },
  // authorityDomain: 'scgchemb2cdev.b2clogin.com',
  authorityDomain: environment.msalConfig.authorityDomainB2C,
};

export function MSALGuardConfigFactoryB2C(): MsalGuardConfiguration {
  return {
    interactionType: InteractionType.Redirect,
    authRequest: {
      // scopes: ['user.read'],
      // scopes: ["https://scgchemb2cdev.onmicrosoft.com/api/tasks.read"],
      // scopes: ['openid', 'https://scgchemb2cdev.onmicrosoft.com/User.Read.All'],
      scopes: ['openid'],
      // domainHint: 'scgchemb2c.onmicrosoft.com',
      // loginHint: 'userlogin@scgchemb2c.onmicrosoft.com',
      //authority: 'https://login.microsoftonline.com/c65c86ae-d084-4c32-9826-9da294b606e5/oauth2/v2.0/authorize?client_id=43197c43-91fd-4bd3-a200-605d995190b6&scope=user.read'//,environment.authorityB2C,
      //authority: 'https://login.microsoftonline.com/c65c86ae-d084-4c32-9826-9da294b606e5/oauth2/v2.0/authorize?client_id=43197c43-91fd-4bd3-a200-605d995190b6&scope=user.read%20openid%20profile%20offline_access&response_type=code&redirect_uri=http%3A%2F%2Flocalhost%3A4200%2F&response_mode=query&sso_reload=true'//,environment.authorityB2C,
      //authority: 'https://scgchemb2c.b2clogin.com/scgchemb2c.onmicrosoft.com/b2c_1_susi_reset_v2'

      //authority: 'https://login.microsoftonline.com/common/v2.0'
    },
    loginFailedRoute: '/login',
  };
}

export function logoutRequest() {
  return {
    postLogoutRedirectUri: environment.msalConfig.redirectUri + '/login',
  };
}
